import { jsx as _jsx } from "react/jsx-runtime";
const maxWidthClasses = {
    sm: 'max-w-[40rem]',
    md: 'max-w-[56rem]',
    lg: 'max-w-[72rem]',
    xl: 'max-w-[80rem]',
};
export function Container({ children, className = '', maxWidth = 'lg' }) {
    return (_jsx("div", { className: `w-full ${maxWidthClasses[maxWidth]} mx-auto px-4 ${className}`, children: children }));
}
//# sourceMappingURL=Container.js.map